import React, { FunctionComponent } from "react";
import { Alert, Snackbar, Box, IconButton, Button } from "@mui/material";
import Icon from '@mdi/react';
import { mdiCheckboxMarkedOutline, mdiCheckCircleOutline, mdiClose, mdiAlertOutline, mdiAlertCircleOutline, mdiCloseCircleOutline } from '@mdi/js';
import { Co2Sharp } from "@mui/icons-material";

type Variant = "neutral" | "primary" | "secondary";
type Level = "success" | "info" | "error" | "warning" | "neutral";

type Action = {
    label: string | "Undo";
    onClick?: () => void;
}

interface IProps {
    open?: boolean;
    message: string
    variant: Variant;
    level: Level;
    action?: Action;
    onClose?: () => void;
}

export const CustomSnackbar: FunctionComponent<IProps> = (props): JSX.Element => {
    let bgColor: string = ""; //alert bg color
    let bgIconColor: string = ""; //background color for icon
    let iconColor: string = ""; //icon color
    let icon: string = ""; //icon
    let borderIconColor: string = "" //in case the level is primary

    switch (props.variant) {
        case "neutral":
            bgColor = "white";

            if (props.level === "success") {
                bgIconColor = "#71db4d";
                iconColor = "#44832e";
                icon = mdiCheckboxMarkedOutline;
            }

            else if (props.level === "info") {
                bgIconColor = "#1ba0e9";
                iconColor = "#10608c";
                icon = mdiAlertCircleOutline;
            }

            else if (props.level === "error") {
                bgIconColor = "#ed3e3e";
                iconColor = "#8e2525";
                icon = mdiCloseCircleOutline;
            }

            else if (props.level === "warning") {
                bgIconColor = "#dbc23e";
                iconColor = "#928129"
                icon = mdiAlertOutline;
            }

            else if (props.level === "neutral") {
                bgIconColor = "";
                iconColor = ""
            }

            break;

        case "primary": {
            iconColor = "white";

            if (props.level === "success") {
                bgColor = "#71db4d";
                borderIconColor = "#a3dd8f";
                icon = mdiCheckCircleOutline;
            }

            else if (props.level === "info") {
                bgColor = "#1ba0e9";
                borderIconColor = "#a3dd8f";
                icon = mdiAlertCircleOutline;
            }

            else if (props.level === "error") {
                bgColor = "#ed3e3e";
                borderIconColor = "#f48b8b";
                icon = mdiCloseCircleOutline;
            }

            else if (props.level === "warning") {
                bgColor = "#dbc23e";
                borderIconColor = "#e9da8b";
                icon = mdiAlertOutline;
            }

            else if (props.level === "neutral") {
                bgColor = "4b5b6b";
            }

            break;
        }

        case "secondary": {
            bgColor = "#12253a";

            if (props.level === "success") {
                bgIconColor = "#71DB4D4D";
                iconColor = "#71DB4D";
                icon = mdiCheckboxMarkedOutline;
            }

            else if (props.level === "info") {
                bgIconColor = "#1BA0E94D";
                iconColor = "#1BA0E9";
                icon = mdiAlertCircleOutline;
            }

            else if (props.level === "warning") {
                bgIconColor = "#F3D7454D";
                iconColor = "#F3D745";
                icon = mdiAlertOutline;
            }

            else if (props.level === "error") {
                bgIconColor = "#ED3E3E4D";
                iconColor = "#ED3E3E";
                icon = mdiCloseCircleOutline;
            }

            break;
        }
    }

    const shapeStyle = { bgcolor: bgIconColor, width: 30, height: 30, border: props.variant === "primary" ? `1px solid ${borderIconColor}` : "" };
    const shapeCircleStyle = { borderRadius: "50%" };

    const AlertIcon = () => {
        return (
            <Box component="span" sx={{ ...shapeStyle, ...shapeCircleStyle, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Icon path={icon} color={iconColor} size={0.8} />
            </Box>
        )
    }
    return (
        <Snackbar 
            open={props.open}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            onClose={props.onClose}
            autoHideDuration={6000}
        >
            <Alert
                icon={<AlertIcon />}
                variant="filled"
                severity="success"
                sx={{
                    bgcolor: bgColor,
                    width: 450,
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    color: props.variant === "neutral" ? "#000000CC" : "white",
                    fontWeight: "bold",
                    fontSize: 16,
                    fontFamily: "Lato",
                    alignItems: "center"
                }}
                action={
                    <>
                        {
                            props.action && (
                                <Button 
                                    variant="text" 
                                    sx={{ 
                                        color: props.variant === "primary" ? "white" : "#1BA0E9", 
                                        textTransform: "none", 
                                        fontWeight: "700", 
                                        fontSize: 14, 
                                        fontFamily: "Lato" 
                                    }}
                                    onClick={props.action.onClick ? props.action.onClick : props.onClose}
                                >
                                    { props.action.label }
                                </Button>
                            )
                        }
                        <IconButton onClick={props.onClose} >
                            <Icon path={mdiClose} size={0.8} color={props.variant === "neutral" ? "rgb(153, 153, 153)" : "white"} />
                        </IconButton>
                    </>
                }
            >
                <strong>{props.message}</strong>
            </Alert>
        </Snackbar>
    )
}